function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodPicnicFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 14H2v2h28v-2zM3 28V18h2v10h22V18h2v10a2 2 0 01-2 2H5a2 2 0 01-2-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.076 12.442a37.421 37.421 0 00-.872-2.02c-2.684-5.756-6.28-9.76-8.032-8.943-1.265.59-1.222 3.53-.091 7.286-3.279-2.883-6.824-4.072-8.248-2.648-1.371 1.37-.319 4.71 2.337 7.883h2.72l-.107-.105c-1.607-1.607-2.701-3.286-3.22-4.632-.26-.676-.34-1.178-.331-1.496a.99.99 0 01.026-.225.99.99 0 01.226-.027c.317-.008.82.072 1.495.332 1.346.518 3.025 1.613 4.632 3.22.982.981 1.773 1.99 2.357 2.933h.158a4 4 0 011.282-2.046c-1.127-2.531-1.824-4.883-2.075-6.657a8.787 8.787 0 01-.101-1.545c.31.24.687.59 1.119 1.07 1.247 1.39 2.665 3.553 3.919 6.187a3.992 3.992 0 012.806 1.433zM12.35 3.006s-.002.008-.01.02a.075.075 0 01.01-.02zm-.768.358s.007 0 .023.006a.082.082 0 01-.022-.006zm-7.307 4.13l-.005.009.005-.01zm-.066.066s.003-.003.01-.006a.03.03 0 01-.01.006z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.972 15h-2.096 2.096zM15.941 15h-2.279 2.28z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.586 9.414A2 2 0 0020 10.828V16h7v-5.172a2 2 0 00-.586-1.414l-.828-.828A2 2 0 0125 7.172V6h-3v1.172a2 2 0 01-.586 1.414l-.828.828zm2.914-.306c-.18.324-.405.625-.672.892l-.828.828V14h3v-3.172L24.172 10a3.998 3.998 0 01-.672-.892z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3h3v2h-3V3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.17 14h5.66a3.001 3.001 0 00-5.66 0zM12 15a5 5 0 0110 0v1H12v-1zM25 20H7v-2h18v2zM25 24H7v-2h18v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 26v-8h2v8h-2zM15 26v-8h2v8h-2zM20 26v-8h2v8h-2z",
    fill: props.color
  }));
}

export default SvgIconFoodPicnicFilled;